export const LABEL = 'LABEL';
export const DATE = 'DATE';
export const RADIO = 'RADIO';
export const MULTIRADIO = 'MULTIRADIO';
export const TEXT = 'TEXT';



// WEBPACK FOOTER //
// ./src/scripts/constants/property-type-constants.js